<template>
    <div class="p-3">
        <h3>Tambah ICD X Details</h3>
        <hr>

        <div class="row">
            <div class="col-sm-12">
                <h4 class="mb-3">Data ICD X Tambah</h4>

                <div class="card">
                    <div class="card-header text-white bg-primary">Tambah ICD X</div>
                    <div class="card-body">
                        <template v-for="(icdx, idx) in update_icdx">
                            <div class="row mb-12" :key="idx" v-if="input_labels[idx]">
                                <label :for="idx" class="col-sm-4 col-form-label text-end">{{ input_labels[idx] }}</label>
                                <div class="col-sm-6">
                                    <input :name="idx" v-if="!inArray(idx, input_filtered)" type="text" :id="idx" class="form-control" v-model="update_icdx[idx]"   @change="validate(idx)">
                                </div>
                            </div>
                        </template>

                        <div class="row">
                            <div class="col text-end">
                                <button class="btn btn-sm btn-success" @click="saveICDX">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            KDICD: '',
            update_icdx: {
                'KDICD': '',
                'DIAGNOSA': '',
                'KDDTD': '',
                'SUBDIAGNOSA': '',

            },
            filter: {
                tanggal_dari: '',
                tanggal_sampai: '',
                search: '',
                page: 1,
            },
            input_labels: {
                'KDICD': 'Kode ICD X',
                'DIAGNOSA': 'Nama ICD X',
                'KDDTD': 'Sub Kode ICD X',
                'SUBDIAGNOSA': 'Sub Nama ICD X',

            },
            input_filtered: [],
        }
    },
    created() {
    },
    mounted() {
    },
    updated() {
      
    },
    methods: {
      
        validate(field) {
        },
        saveICDX() {
            const uri = '/api/master-icdx/save-icdx'
            this.axios.post(uri, {data_icdx: this.update_icdx}).then(response => {
                if (response.data.status == 'success') {
                    this.$router.push({
                        name: 'master_icdx'
                    })
                } else {
                    this.$swal.fire({
                        title: 'Error!',
                        text: response.data.message,
                        icon: 'error',
                        confirmButtonText: 'OK'
                    })
                }
            })
        },
      
    }
}
</script>